import { apiRequest } from ".";

export const getBrokerCommissionsRequest = (filters) => {
  const {
    page='',
    limit='',
    broker='',
    year=''
  } = filters;

  return apiRequest(
    `/admin/broker-commissions?page=${page}&limit=${limit}&broker=${broker}&year=${year}`,
    {
      method: 'GET'
    },
    true
  )
}

export const getBrokerCommissionRequest = (id) => {
  return apiRequest(
    `/admin/broker-commissions/${id}`,
    {
      method: 'GET'
    },
    true
  )
}

export const createBrokerCommissionRequest = (brokerCommission) => {
  return apiRequest(
    `/admin/broker-commissions`,
    {
      method: 'POST',
      body: JSON.stringify(brokerCommission)
    },
    true
  )
}   

export const updateBrokerCommissionRequest = (brokerCommission) => {
  return apiRequest(
    `/admin/broker-commissions/${brokerCommission._id}`,
    {
      method: 'PUT',
      body: brokerCommission
    },
    true
  )
}

export const deleteBrokerCommissionRequest = (id) => {
  return apiRequest(
    `/admin/broker-commissions/${id}`,
    {
      method: 'DELETE'
    },
    true
  )
} 